/** @format */

import customAxios from "./axios";
import CONFIG from "../../config";

export const create = (payload) => {
  return customAxios.post(CONFIG.apiURL + "/Payments/SendPaymentLink", payload).then((res) => {
    return res;
  });
};

export const getAll = (payload) => {
  return customAxios.post(CONFIG.apiURL + "/Payments/GetAllPayproLinkRequests", payload).then((res) => {
    return res["data"];
  });
};
export const paymentLinkExportCsv = (payload) => {
  return customAxios.post(CONFIG.apiURL + "/Payments/GetPayproLinkRequestsAsCsv", payload).then((res) => {
    return res;
  });
};export const payVoucher = (id) => {
  return customAxios.get(CONFIG.apiURL + "/Payments/DownloadExternalPaymentVoucher?Id=" + id, { responseType: 'blob' }).then((res) => {
    return res;
  });
};
export const corporateCompanyJobPaymentVoucher = (id) => {
  return customAxios.get(CONFIG.apiURL + "/Payments/DownloadCorporateCompanyJobPaymentVoucher?Id=" + id, { responseType: 'blob' }).then((res) => {
    return res;
  });
};
